"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); } // eslint-disable-next-line @typescript-eslint/no-unused-vars
var RIOTBAR_SCRIPT_ID = "riotbar-script";
var RiotBarLoader = exports["default"] = /*#__PURE__*/function (_Component) {
  _inherits(RiotBarLoader, _Component);
  var _super = _createSuper(RiotBarLoader);
  function RiotBarLoader(props) {
    _classCallCheck(this, RiotBarLoader);
    return _super.call(this, props);
  }
  _createClass(RiotBarLoader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // start loading
      this.loadRiotBar();
    }
  }, {
    key: "render",
    value: function render() {
      return null; // we dont actually render anything, the riotbar script does
    }
  }, {
    key: "getRiotBarUrl",
    value: function getRiotBarUrl() {
      var _this$props = this.props,
        _this$props$environme = _this$props.environment,
        environment = _this$props$environme === void 0 ? "live" : _this$props$environme,
        _this$props$version = _this$props.version,
        version = _this$props$version === void 0 ? "latest" : _this$props$version,
        locale = _this$props.locale,
        product = _this$props.product;
      var cdnHost = "cdn.rgpub.io";
      var standardEnvironments = ["test", "preview", "live", "stage-live"];
      var invalidLiveEnvironments = ["production", "prod"];
      var accessLevel = "private";
      if (invalidLiveEnvironments.includes(environment)) {
        throw new Error("invalid environment name, please use `live` to access the production riotbar");
      }
      if (environment === "live") {
        accessLevel = "public";
      }
      if (!standardEnvironments.includes(environment)) {
        console.warn("you are using a nonstandard riotbar environment: ".concat(environment));
      }
      return "https://".concat(cdnHost, "/").concat(accessLevel, "/").concat(environment, "/riotbar/").concat(version, "/").concat(product, ".").concat(locale, ".js");
    }
  }, {
    key: "loadRiotBar",
    value: function loadRiotBar() {
      if (!document.getElementById(RIOTBAR_SCRIPT_ID)) {
        var scriptEl = document.createElement("script");
        scriptEl.src = this.getRiotBarUrl();
        scriptEl.id = RIOTBAR_SCRIPT_ID;
        if (this.props.onLoad && typeof this.props.onLoad === "function") {
          var onloadFunc = this.props.onLoad;
          document.addEventListener("riotbar_onshowcomplete", function () {
            onloadFunc();
          });
        }
        if (this.props.onAuthUpdate && typeof this.props.onAuthUpdate === "function") {
          var onAuthUpdateFunc = this.props.onAuthUpdate;
          document.addEventListener("riotbar_authcheckcomplete", function () {
            onAuthUpdateFunc();
          });
        }
        document.getElementsByTagName("head")[0].appendChild(scriptEl);
      }
    }
  }]);
  return RiotBarLoader;
}(_react.Component);